import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Modal } from "react-bootstrap";
import { FormProvider, useForm } from "react-hook-form";

import { CloseAdminModalIcon } from "../../assets";
import PropertyTypesIconMapping from "../../assets/icons/PropertyTypesIconMapping";
import { ERROR_TOAST } from "../../constants/toast.constants";
import { EMPTY_STRING, surveyFiledsTypes } from "../../constants";
import { customToast } from "../../shared/utility";
import CustomSvg from "../../shared/components/custom-svg/CustomSvg";
import RoundedButton from "../../shared/components/buttons/RoundedButton";
import SurveyFormField from "../../shared/components/surveyFormField/SurveyFormField";
import { propertyActions } from "../../redux/actions";

const { TYPE_RADIO } = surveyFiledsTypes;

const AddPropertyTypeModal = ({
  show,
  onClose,
  allPropertyTypes,
  getAllPropertyTypes,
  userPropertyTypes,
  handleAdd = () => {},
}) => {
  const methods = useForm({
    mode: "onChange",
  });

  const { getValues, setValue } = methods;

  useEffect(() => {
    getAllPropertyTypes();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (show) {
      const selectedOption = userPropertyTypes?.map((item) => item.id) || [];
      setValue("types", [...selectedOption]);
    } else {
      setValue("types", []);
    }

    // eslint-disable-next-line
  }, [show]);

  const onAddClick = () => {
    const selectedPropertyTypes = getValues("types");
    if (selectedPropertyTypes && selectedPropertyTypes.length > 0) {
      handleAdd({ propertyTypeIds: selectedPropertyTypes });
    } else {
      customToast("Please select at least one property type.", ERROR_TOAST);
    }
  };

  return (
    <Modal
      show={show}
      onHide={onClose}
      contentClassName="bg-light"
      centered
      className="home-modal"
    >
      <Modal.Header>
        <div className="d-flex justify-content-between w-100">
          <div className="property-type-modal-heading">Add Property Type</div>
          <img
            src={CloseAdminModalIcon}
            className="pointer"
            onClick={onClose}
            alt={EMPTY_STRING}
          />
        </div>
      </Modal.Header>
      <Modal.Body className="home-modal-body">
        <div className="d-flex gap-2 flex-wrap">
          <FormProvider {...methods}>
            <form>
              {allPropertyTypes.map((type) => (
                <SurveyFormField
                  name="types"
                  multiple
                  key={type.id}
                  variant={TYPE_RADIO}
                  label={type.title}
                  value={type.id}
                  endAdornment={
                    <div className="position-absolute marks-adornment">
                      <CustomSvg
                        src={PropertyTypesIconMapping[type.icon]}
                        className="property-types-icon"
                      />
                    </div>
                  }
                />
              ))}
            </form>
          </FormProvider>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <RoundedButton onClick={onAddClick} className="px-4">
          Submit
        </RoundedButton>
        <RoundedButton
          variant="outlined-blue"
          onClick={onClose}
          className="px-4"
        >
          Cancel
        </RoundedButton>
      </Modal.Footer>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  allPropertyTypes: state.propertyReducer.allPropertyTypes,
});

const mapDispatchToProps = (dispatch) => ({
  getAllPropertyTypes: () => dispatch(propertyActions.getAllPropertyTypes()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddPropertyTypeModal);
